export function toggleTargetGroupMember(memberIds = [], memberId, selected) {
  const normalizedId = Number(memberId);
  const current = (memberIds || []).map(Number).filter(Number.isInteger);
  if (selected) return Array.from(new Set([...current, normalizedId]));
  return current.filter((id) => id !== normalizedId);
}

export function resolveSchedulerTargetGroupDeviceIds(group, itemType) {
  if (!group?.resolution) return [];
  const screenDeviceIds = group.resolution.screenDeviceIds || [];
  if (itemType === 'event') return screenDeviceIds.map(Number).filter(Number.isInteger);
  return (group.resolution.deviceIds || []).map(Number).filter(Number.isInteger);
}

export function targetGroupAvailabilityMessage(group) {
  const diagnostics = group?.resolution?.diagnostics;
  if (!diagnostics?.canPublish) return 'No compatible endpoints are currently resolved.';
  if (diagnostics.issues?.length) {
    return `${diagnostics.issues.length} unavailable member(s) will be reported; compatible targets remain scheduled.`;
  }
  return 'Membership follows the Logical Topology automatically.';
}
